module.exports = __webpack_public_path__ + "static/img/reward_get_none.98a4ea74.png";